/**
 * Normalize an app-internal label (e.g. a hardcoded step name) into
 * lower_snake_case. DO NOT apply to external input (query params, user
 * input, opaque IDs, URLs).
 */
export function normalizeToLowerSnakeCase(value, fallback) {
  if (value == null || value === '') return fallback;
  return String(value).toLowerCase().replace(/[\s-]+/g, '_');
}

/**
 * First non-empty string from analytics_info (camelCase or snake_case keys).
 */
export function analyticsInfoString(info, ...keys) {
  if (!info || typeof info !== 'object') return '';
  for (const key of keys) {
    const value = info[key];
    if (value != null && value !== '') return String(value);
  }
  return '';
}
